import { render, staticRenderFns } from "./PlatformCustomers.vue?vue&type=template&id=5892dc0e"
import script from "./PlatformCustomers.vue?vue&type=script&lang=js"
export * from "./PlatformCustomers.vue?vue&type=script&lang=js"
import style0 from "./PlatformCustomers.vue?vue&type=style&index=0&id=5892dc0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports